import axios from "axios";
import { create } from "zustand";

const brandStore = create((set) => ({
  brand: null,

  fetchBrand: async () => {
    // Fetch brand
    const res = await axios.get("/brand");
    // set brand to state
    set({ brand: res.data.brand });
  },
}));

export default brandStore;
